<template>
  <span class="reduction-display" v-if="afterPrice && afterPrice > 0 && afterPrice < beforePrice">
    <b-tag class="has-text-weight-semibold reduction-display__tag" type="is-danger" :size="size" v-if="!textOnly">
      <span v-if="suggest">{{ $t('general.up-to') }}</span>
      -{{ percentageDisplay }}%
    </b-tag>
    <span v-if="textOnly">
      <span v-if="suggest">{{ $t('general.up-to') }}</span>
      -{{ percentageDisplay }}%
    </span>
  </span>
</template>

<script>
export default {
  name: 'ReductionDisplay',
  props: {
    beforePrice: Number,
    afterPrice: Number,
    suggest: Boolean,
    size: String,
    textOnly: Boolean,
  },
  computed: {
    percentageDisplay() {
      if (this.beforePrice && this.beforePrice > 0 && this.beforePrice > this.afterPrice) {
        return Math.round((1 - this.afterPrice / this.beforePrice) * 100)
      }
      return ''
    },
  },
}
</script>

<style scoped lang="sass"></style>
